<template>
  <app-notification
    v-if="shouldDisplayErrorNotification"
    class="error-notification"
    :active-notification="shouldDisplayErrorNotification"
    :additional-text="errorMessageKey"
    is-error-notification
  >
    <template #additional-content>
      <button
        v-if="shouldDisplaySendReportButton"
        class="error-notification__report-button button--transparent"
        @click="sendBugReport"
      >
        {{ $t('common.sendReportLabel') }}
      </button>
    </template>
  </app-notification>
</template>

<script>
import { AppErrorService } from '@/services/AppErrorService';
import { sendReport } from '@/api/error.api';

import { LONG_NOTIFICATION_DURATION } from '@/constants/common';

export default {
  name: 'AppErrorNotification',
  components: { AppNotification: () => import('@/components/common/AppNotification.vue') },
  data() {
    return {
      errorMessageKey: '',
      shouldDisplayErrorNotification: false,
      errorState: AppErrorService.getErrorsState(),
      currentError: null,
      shouldDisplaySendReportButton: false
    };
  },
  watch: {
    errorState: {
      handler: 'displayErrorMessage',
      immediate: true,
      deep: true
    }
  },
  methods: {
    displayErrorMessage({ errors: [errorEnvelope] }) {
      if (!errorEnvelope) {
        return;
      }
      const { details = {} } = errorEnvelope;

      this.currentError = errorEnvelope;
      const { message, withSendReport } = details;

      this.errorMessageKey = message || 'common.errorNotification.oops';
      this.shouldDisplaySendReportButton = withSendReport;
      this.shouldDisplayErrorNotification = true;

      setTimeout(this.closeNotification, LONG_NOTIFICATION_DURATION);
    },
    closeNotification() {
      this.shouldDisplayErrorNotification = false;
      AppErrorService.removeError(this.currentError);
      this.currentError = null;
    },
    async sendBugReport() {
      if (!this.currentError) {
        return;
      }

      const report = {
        browser: navigator.userAgent,
        date: new Date().toString(),
        details: JSON.stringify(this.currentError.error)
      };

      await sendReport(report);

      this.closeNotification();
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/notifications';
@import '../../assets/scss/buttons.scss';
@import '../../assets/scss/colors.scss';

.error-notification {
  &__report-button {
    align-self: center;
    margin-top: 15px;
    padding: 10px;
    color: $dove-gray-color;
    border: 1px solid $silver-color;
    border-radius: 5px;

    &:hover {
      background-color: $gallery-color;
    }
  }
}
</style>
